<template>
  <div>
    <CRow>
      <CCol xs="12" sm="4" md="3" lg="3" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }"
                     is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol v-if="$hasAuthor('ROLE_ADMIN')" xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect :options="orgSelect.options" :data="orgSelect.data"
                    ref="orgSelect"></BaseSelect>
      </CCol>
      <CCol v-if="!$hasAuthor('ROLE_ADMIN')" xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect
          :options="historyType.options"
          :data="historyType.data"
          ref="historyType"
        ></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect
          :options="fileType.options"
          :data="fileType.data"
          ref="fileType"
        ></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect :options="deviceInput.options" :data="deviceInput.data" ref="deviceInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseInput
          :options="titleFileInput.options"
          :data="titleFileInput.data"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)"
            >
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #serialId="{ item }">
            <td>
              <span class="badge badge-secondary">{{
                  item.serialId + ' - ' + (item.description != null && item.description != '' ? item.description : 'Chưa khai báo')
                }}</span>
            </td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null"></td>
          </template>
          <template #updateDate="{ item }">
            <td v-if="item.updateDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.updateDate) }}
            </td>
            <td v-if="item.updateDate == null"></td>
          </template>
          <template #status="{ item }">
            <td>
              <span class="badge badge-warning" v-if="item.status == 0">Đang phát</span>
              <span class="badge badge-success" v-else-if="item.status == 1">Đã phát</span>
              <span class="badge badge-danger" v-else-if="item.status == 2">Phát lỗi</span>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";
import {HistoryTypeList} from '../../constant';

export default {
  name: "HistoryList",
  components: {
    BaseFormLoading,
    BaseTable,
    BaseInput,
    BaseSelect,
    DatePicker,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    return {
      loading: {value: false},
      dateRange: {
        start: new Date().setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      orgSelect: {
        options: {
          label: "Đơn vị",
          selectAllText: "Tất cả đơn vị",
          filter: true,
          keyField: "value",
          valueField: "text",
          lazyLoad: that.$hasAuthor("ROLE_ADMIN") ? false : true
        },
        data: {
          model: "",
          name: "orgId",
          source: {
            url: "/organization/list-org-active",
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
          // updateTrigger: function () {
          //   return that.$refs.mainTable;
          // },
        },
      },
      historyType: {
        options: {
          filter: false,
          label: "Trạng thái",
        },
        data: {
          name: "status",
          items: HistoryTypeList,
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      titleFileInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: 'Tiêu đề bản tin'
        },
        data: {
          name: "titleFile",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      deviceInput: {
        options: {
          filter: true,
          label: "Thiết bị",
          selectAllText: "Tất cả thiết bị",
          'keyField': 'value',
          'valueField': 'text'
        },
        data: {
          name: "deviceId",
          model: null,
          items: [],
          source: {
            url: '/devices/find-all',
            dataSubmit: function () {
              return {
                orgId: that.orgSelect.data.model
              }
            },
            isJsonContentType: false,
            response: function (dataResponse) {
              that.deviceInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      fileType: {
        options: {
          filter: false,
          label: "Loại bản tin",
        },
        data: {
          name: "fileType",
          items: [
            {
              key: "null",
              value: "Tất cả loại bản tin"
            },
            {
              key: "-1",
              value: "Văn bản chữ chạy"
            },
            {
              key: "0",
              value: "Văn bản"
            },
            {
              key: "1",
              value: "Hình ảnh"
            },
            {
              key: "2",
              value: "Video"
            },
            {
              key: "-2",
              value: "Youtube"
            },
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "createDate", label: "Thời gian tạo"},
            {key: "updateDate", label: "Thời gian cập nhật"},
            {key: "fileTitle", label: "Bản tin"},
            {key: "slideTitle", label: "Trình diễn"},
            {key: "serialId", label: "Mã thiết bị"},
            {key: "status", label: "Trạng thái"},
          ],
          slots: [
            "index",
            "serialId",
            "createDate",
            "updateDate",
            "status"
          ],
          lazyLoad: false,
          sorter: true,
          columnFilter: false,
          tableFilter: false,
        },
        dataSource: {
          url: "/history/getPages",
          dataSubmit: function () {
            // return that.$helper.setupDataSubmit(that.$data);
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDate(that.dateRange.start);
            params.toDate = that.$helper.formatDate(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    },
    'orgSelect.data.model': function () {
      this.loadDataMainTable();
      this.$refs.deviceInput.loadData();
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
